import { IEmailTemplate, TypeEmailTemplates } from "@evennt-tech/api-v2-core";
import { useShowEmailTemplates } from "store/email-templates";
import { shallow } from "zustand/shallow";
import { useEffect } from "react";

type UseEmailTemplateArgs = {
  type: TypeEmailTemplates;
  showId: string;
};

export type UserEmailTemplateRes = {
  emailTemplate: IEmailTemplate | null;
  isLoading: boolean;
  isLoaded: boolean;
};

function useEmailTemplate({
  type,
  showId,
}: UseEmailTemplateArgs): UserEmailTemplateRes {
  const {
    fetch: fetchEmailTemplatesInShow,
    autoCatch: autoCatchEmailTemplates,
  } = useShowEmailTemplates();

  const emailTemplate = useShowEmailTemplates(
    (state) => state.getCustomByType(showId as string, type),
    shallow
  );

  const isLoading = useShowEmailTemplates((state) => state.isLoading, shallow);

  const isLoaded = useShowEmailTemplates(
    (state) => state.isLoaded && state.showId === showId
  );

  useEffect(() => {
    const load = async () => {
      await autoCatchEmailTemplates(showId);
      await fetchEmailTemplatesInShow(showId);
    };

    load();
  }, []);

  return {
    emailTemplate,
    isLoading,
    isLoaded,
  };
}

export default useEmailTemplate;
